import { render } from "./HeaderPrincipal.vue?vue&type=template&id=3d0528a7&scoped=true"
import script from "./HeaderPrincipal.vue?vue&type=script&lang=js"
export * from "./HeaderPrincipal.vue?vue&type=script&lang=js"

import "./HeaderPrincipal.vue?vue&type=style&index=0&id=3d0528a7&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3986129723/src/app-csd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0528a7"]])

export default __exports__